import { AppGlueCorePlugins } from "../../rule-engine-core/AppGlueCorePlugins";
import { MenuItem, Select, SxProps } from "@mui/material";

export interface UIFontSelectProps {
    sx?: SxProps;
    selectedFont?: string;
    onChange: (newFont: string) => void;
    error?: string;
}

export function UIFontSelect(props: UIFontSelectProps) {
    return (
        <Select
            sx={props.sx}
            style={{ fontFamily: props.selectedFont }}
            defaultValue={props.selectedFont}
            value={props.selectedFont}
            size={"small"}
            error={Boolean(props.error)}
            variant={"outlined"}
            onChange={(e) => {
                e.preventDefault();
                // @ts-ignore
                props.onChange(e.target.value);
            }}
        >
            <MenuItem value={undefined}>[Default Font]</MenuItem>
            {AppGlueCorePlugins.fontList.map((f) => {
                return (
                    <MenuItem
                        value={f}
                        style={{ fontFamily: f }}
                    >
                        {f}
                    </MenuItem>
                );
            })}
        </Select>
    );
}
